var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.update.author.email === _vm.$store.state.email && _vm.thanks.length !== 0)?_c('div',{staticClass:"thanks-container"},[_c('p',{staticClass:"thanks-number"},[_vm._v(" "+_vm._s(_vm.thanks.length)+" teammate"+_vm._s(_vm.thanks.length === 1 ? '' : 's')+" thanked you! ("+_vm._s(_vm.thanks.join(', '))+") ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }